var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-container" },
    [
      _c(
        "el-scrollbar",
        { staticStyle: { width: "100%", height: "100%" } },
        [
          _vm.formConfig.formKey
            ? _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "Mobile" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("i", { staticClass: "el-icon-mobile" }),
                      _vm._v(" 手机 "),
                    ]),
                    _c(
                      "div",
                      {
                        style: {
                          width: _vm.previewQrcode ? "800px" : "400px",
                          position: _vm.previewQrcode ? "relative" : "",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: { "preview-phone": _vm.curTab == "Mobile" },
                            staticStyle: { "margin-top": "20px" },
                          },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "preview-html": _vm.curTab == "Mobile",
                                },
                              },
                              [
                                _vm.formConfig.formKey
                                  ? _c("biz-project-form", {
                                      ref: "projectFormRefMobile",
                                      attrs: {
                                        "form-config": _vm.formConfig,
                                        requestUrl: _vm.detailUrl,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm.mobilePreviewUrl && _vm.previewQrcode
                          ? _c("div", { staticClass: "qrcode-view" }, [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "16px",
                                  },
                                },
                                [_vm._v("手机扫码预览")]
                              ),
                              _c("p", { staticClass: "tips-text" }, [
                                _vm._v("* 当前为预览页，答案不被记录"),
                              ]),
                              _c(
                                "p",
                                [
                                  _vm.mobilePreviewUrl && _vm.previewQrcode
                                    ? _c("vue-qr", {
                                        staticStyle: {
                                          "border-radius": "10px",
                                        },
                                        attrs: {
                                          size: 134,
                                          text: _vm.mobilePreviewUrl,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "Pc" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("i", { staticClass: "el-icon-monitor" }),
                      _vm._v(" 电脑 "),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "preview-pc",
                        staticStyle: { "margin-top": "20px" },
                      },
                      [
                        _vm.formConfig.formKey && _vm.curTab == "Pc"
                          ? _c("biz-project-form", {
                              ref: "projectFormRefPc",
                              attrs: {
                                "form-config": _vm.formConfig,
                                requestUrl: _vm.detailUrl,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }